<template>
        
    <div v-if="isLoading" class="spinner text-center">
        
        <img width="100" src="https://cdn.gavleenergi.se/img/spinner.svg">
        
    </div>
    <div v-else>
 
        <div class="outageinfo">

            <div class="mb-5" id="active">
            <h4 class="mb-3 fs-4">Pågående</h4>
 
            <div class="outageinfoItem card mb-3" v-for="item in activeItems" :key="item.id">
                <div class="card-header">
                    <strong class="mb-0 py-2">
                        <div v-if="item.from === 'informera'">
                            <i class="me-2 fa-fw fa-regular fa-triangle-exclamation"></i>  
                            {{ item.title }}
                        </div>
                        <div v-else>
                            <i class="me-2 fa-fw" :class="{
                            'fa-regular fa-lightbulb-slash': item.network_type === 'Elnät',
                            'fak fa-bionar-off': item.network_type === 'Fjärrvärme',
                            'fa-regular fa-wifi-slash': item.network_type === 'Gavlenet',
                            'fa-regular fa-triangle-exclamation': item.network_type === ''
                            }"></i>                                
                            {{item.type }} <span v-if="item.areas">- {{ item.areas }}</span>
                        </div>                                                
                        
                    </strong>
                </div>
                <div class="card-body">
             

                        <div v-if="item.from === 'informera'">
                            <div v-html="item.description"></div>
                        </div>
                        <div v-else>
                            <p class="mb-0"><span class="badge bg-primary me-2">{{item.network_type }}</span> {{ item.status_info2_text }}</p>
                        </div>

                        <div class="innerWrapper">
                            <dl>
                                <dt>Starttid</dt>
                                <dd>{{ formatDate(item.starttime) }}</dd>
                                <dt>Beräknad sluttid</dt>
                                <dd v-if="item.status_info_text">{{ item.status_info_text }}</dd>
                                <dd v-else>{{ formatDate(item.endtime) }}</dd>
                            </dl>
                            <dl v-if="item.from === 'trimble'">
                                <dt>Status</dt>
                                <dd>{{ item.status_text }}</dd>
                                <dt v-if="item.customer_count_in_outage != null && item.customer_count_in_outage != 0">Berörda kunder</dt>
                                <dd v-if="item.customer_count_in_outage != null && item.customer_count_in_outage != 0">
                                    {{ item.customer_count_in_outage }}
                                </dd>                            
                            </dl>
                        </div>
                </div>
            </div>
            <div v-if="activeItems.length<1">
                Just nu har vi inga driftavbrott.
            </div>

            </div>

            <h4 v-if="plannedItems.length>0" class="mb-3 fs-4">Planerade</h4>

            <div class="accordion mb-5" id="planned">

                <div class="accordion-item outageinfoItem" v-for="item in plannedItems" :key="item.id">
                        <strong class="accordion-header">
                            <div class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-'+item.id" aria-expanded="false" :aria-controls="'flush-'+item.id">   
                                <div v-if="item.from === 'informera'" style="line-height: 1.5em;">
                                    {{ item.title }} <br>
                                <div class="small fw-normal">{{ formatDate(item.starttime) }} - {{ formatDate(item.endtime) }}</div>
                                </div>
                                <div v-else  style="line-height: 1.5em;">
                                    {{item.type }} <span v-if="item.areas">- {{ item.areas }}</span>
                                   <div class="small fw-normal">{{ formatDate(item.starttime) }} - {{ formatDate(item.estimated_end_time) }}</div>
                                </div>
                               
                            </div>
                        </strong>
                    
                    <div :id="'flush-'+item.id" class="accordion-collapse collapse" data-bs-parent="#planned">
                    
                    <div class="accordion-body">
                                <div v-if="item.from === 'informera'">
                                    <div v-html="item.description"></div>
                                </div>
                                <div v-else>
                                    <span class="badge bg-primary me-2">{{item.network_type }}</span> {{ item.status_info2_text }}
                                </div>

                            <div class="innerWrapper">
                                <dl>
                                    <dt>Starttid</dt>
                                    <dd>{{ formatDate(item.starttime) }}</dd>
                                    <dt>Sluttid</dt>
                                    <dd v-if="item.estimated_end_time">{{ formatDate(item.estimated_end_time) }}</dd>
                                    <dd v-else>{{ formatDate(item.endtime) }}</dd>
                                </dl>
                                <dl v-if="item.from === 'trimble'">
                                    <dt>Status</dt>
                                    <dd>{{ item.status_text }}</dd>
                                    <dt v-if="item.customer_count != null && item.customer_count != 0">Berörda kunder</dt>
                                    <dd v-if="item.customer_count != null && item.customer_count != 0">{{ item.customer_count }}</dd>


                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <h4 class="mb-3">Avslutade</h4>

            <div class="accordion mb-5" id="closed">

                <div class="accordion-item outageinfoItem" v-for="item in closedItems" :key="item.id">
                        <strong class="accordion-header">
                            <div class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-'+item.id" aria-expanded="false" :aria-controls="'flush-'+item.id">   
                                <div v-if="item.from === 'informera'">
                                    {{ item.title }}
                                </div>
                                <div v-else>
                                    {{item.type }} <span v-if="item.areas">- {{ item.areas }}</span>
                                </div>
                            </div>
                        </strong>
                    
                    <div :id="'flush-'+item.id" class="accordion-collapse collapse" data-bs-parent="#closed">
                    
                    <div class="accordion-body">
                                <div v-if="item.from === 'informera'">
                                    <div v-html="item.description"></div>
                                </div>
                                <div v-else>
                                    <span class="badge bg-primary me-2">{{item.network_type }}</span> {{ item.status_info2_text }}
                                </div>

                            <div class="innerWrapper">
                                <dl>
                                    <dt>Starttid</dt>
                                    <dd>{{ formatDate(item.starttime) }}</dd>
                                    <dt>Sluttid</dt>
                                    <dd v-if="item.endtime">{{ formatDate(item.endtime) }}</dd>
                                    <!--<dd v-else>{{ formatDate(item.endtime) }}</dd>-->
                                </dl>
                                <dl v-if="item.from === 'trimble'">
                                    <dt>Status</dt>
                                    <dd>{{ item.status_text }}</dd>
                                    <dt v-if="item.customer_count != null && item.customer_count != 0">Berörda kunder</dt>
                                    <dd v-if="item.customer_count != null && item.customer_count != 0">{{ item.customer_count }}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<ComponentStyles>

    .outageinfoItem dl {
        margin: 10px 0 0 0;
    }

    .outageinfoItem dt {
        font-weight: 400;
        font-size: 12px;
    }

    .outageinfoItem dd {
        font-weight: 600;
        font-size: 16px;
        padding-bottom: .5rem;
        margin: 0;
    }
    
    .outageinfoItem .innerWrapper {
        max-width: 400px;
    }

    @media(min-width: 768px) {
        .outageinfoItem .innerWrapper {
            display:flex;
            justify-content: space-between;
        }
    }

      
</ComponentStyles>
</template>


  <script> 

  import ComponentStyles from "../componentStyles.vue";
  export default {
    
    components: { ComponentStyles } ,
    data() {
    return {
        isLoading: false,
        activeItems: [], 
        plannedItems: [], 
        closedItems: [], 
 
    };
    
  },
    
    methods: {

        formatDate(timestamp) {
             if (!timestamp || typeof timestamp != 'string') {
                return '-';
            }
            return timestamp.slice(0, 16);
         },
        async getData() {
            this.isLoading = true;
            try {
                const response = await fetch('https://apps.gavleenergi.se/powerplant-webservice/servicepoint/driftinfo/', {headers: {"api-key": "nwQQXBgTdKwHsvq"}});
                const data = await response.json();
                this.activeItems = data.active;
                this.plannedItems = data.planned;
                this.closedItems = data.closed;
                console.log(this.closedItems);
            } catch (error) {
                console.error('Error:', error);
            } finally {
                this.isLoading = false;
            }
        },

    },
  
    watch:{},
  
    mounted() {
        this.getData();
    },
  };
  </script>
